(() => {
  const AMAZON_EVENT_NAME = 'maixora_amazon_click';

  function updateAmazonVariant(link) {
    const section = link.closest('.shopify-section') || document;
    const variantInput = section.querySelector('input.product-variant-id');

    if (variantInput?.value) {
      link.dataset.variantId = variantInput.value;
    }
  }

  function publishAmazonClick(link) {
    const detail = {
      event: AMAZON_EVENT_NAME,
      product_id: link.dataset.productId || '',
      product_handle: link.dataset.productHandle || '',
      variant_id: link.dataset.variantId || '',
      destination: link.href,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent(AMAZON_EVENT_NAME, { detail }));
  }

  document.addEventListener('change', (event) => {
    const section = event.target.closest('.shopify-section');
    if (!section) return;

    section.querySelectorAll('[data-maixora-amazon-link]').forEach((link) => {
      requestAnimationFrame(() => updateAmazonVariant(link));
    });
  });

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-maixora-amazon-link]');
    if (!link) return;

    updateAmazonVariant(link);
    publishAmazonClick(link);
  });

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-maixora-amazon-link]').forEach(updateAmazonVariant);
  });
})();
